var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 141,
    viewBox: "0 0 425 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_2916)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428 39.6353V134.305C428 136.205 428 141 428 141C428 141 423.133 141 421.277 141H4.03393C2.55482 141 1.21018 140.464 0 139.661C54.727 137.385 267.584 123.191 428 39.6353Z",
    fill: "#DE5738"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428 0V134.305C428 136.205 428 141 428 141C428 141 423.133 141 421.277 141H236.657C280.089 125.601 364.802 86.5014 428 0Z",
    fill: "#DE5738"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428 50.0798V134.439C428 136.339 428 141.134 428 141.134C428 141.134 423.133 141.134 421.277 141.134H164.45C324.194 126.539 402.183 71.7721 428 50.0798Z",
    fill: "#DE5738"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428 55.7036V134.305C428 136.205 428 141 428 141C428 141 423.133 141 421.277 141C417.512 141 329.438 141 329.438 141C385.106 118.772 415.495 77.1281 428 55.7036Z",
    fill: "#DE5738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_2916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 141,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/Bg1.a1cd602d.svg";
export { ForwardRef as ReactComponent };